import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { generateArticleUrl, getProp } from './../../ui/src/utilities.js';
import StandardArticle from '../component/standardArticle';
import CsmArticle from '../component/csmArticle/csmArticle';
import { CsmSectionLink } from './../../ui/src/component/csmSectionLink';
import { Pill } from '../../ui/src/component/pill';
import { CsmArticlePanorama } from './../../ui/src/component/csmArticlePanorama';
import { imageResizeBaseUrl } from './../../ui/src/utilities';
import { Spinner } from './../../ui/src/component/spinner';
import RelatedArticlesBanner from './RelatedArticlesBanner';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router';
import { Icon } from '../../ui/src/component/icon';
import { fetchArticleDetail } from '../actions.js';

class ArticleDetail extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      maxHeight: 'auto',
      itemHeight: 'auto',
      overflow: 'auto',
    };
    this.topOfContentEl = null;
    this.getMaxHeight = this.getMaxHeight.bind(this);
    this.setMaxHeight = this.setMaxHeight.bind(this);
  }
  componentDidMount() {
    window.addEventListener('load', this.setMaxHeight);
  }
  componentDidUpdate() {
    const maxHeight = this.getMaxHeight();
    if (maxHeight) {
      if (maxHeight.maxHeight !== this.state.maxHeight) {
        this.setState({
          maxHeight: maxHeight.maxHeight,
          itemHeight: maxHeight.itemHeight,
          overflow: 'hidden',
        });
      }
    }
  }
  componentWillReceiveProps(nextProps) {
    if (this.props.id !== nextProps.id) {
      this.setState({
        overflow: 'hidden',
      });
    }
  }
  shouldComponentUpdate(nextProps, nextState) {
    const relatedArticles =
      this.props.relatedArticles || getProp(this.props.detail, 'articles', []);
    const nextRelatedArticles =
      nextProps.relatedArticles || getProp(nextProps.detail, 'articles', []);
    if (
      this.props.id !== nextProps.id ||
      relatedArticles.length !== nextRelatedArticles.length ||
      this.state.maxHeight !== nextState.maxHeight ||
      this.state.overflow !== nextState.overflow
    ) {
      return true;
    }
    return false;
  }
  getMaxHeight() {
    const item = document.getElementsByClassName('relatedArticleItem');
    const content = document.getElementsByClassName('measurableContent');
    const relatedArticles =
      this.props.relatedArticles || getProp(this.props.detail, 'articles', []);
    if (item[0]) {
      const itemHeight = item[0].clientHeight;
      const contentHeight = content[0].clientHeight;
      const divided = contentHeight / itemHeight;
      const maxHeight = Math.ceil(divided) * itemHeight;
      const fullHeight = itemHeight * relatedArticles.length;
      if (maxHeight < fullHeight) {
        return {
          maxHeight: maxHeight,
          itemHeight: itemHeight,
        };
      } else {
        this.props.dispatch(
          fetchArticleDetail(this.props.id, relatedArticles.length * 2),
        );
      }
    }
    return null;
  }
  setMaxHeight() {
    const maxHeight = this.getMaxHeight();
    if (maxHeight) {
      this.setState({
        maxHeight: maxHeight.maxHeight,
        itemHeight: maxHeight.itemHeight,
        overflow: 'hidden',
      });
    }
  }

  render() {
    const { locationSmartTags, preview } = this.props;
    let article = this.props.articles.byId[this.props.id];
    if (this.props.article) {
      article = {
        path: [],
        content: this.props.article,
      };
    }
    if (!article) {
      return <Spinner show={true} />;
    }

    const content = article.content;
    const relatedArticles =
      this.props.relatedArticles || getProp(this.props.detail, 'articles', []);

    // Zobrazenie piluliek v headeri clanku
    // zobrazenie lokalita a potom vsetkych kategorii (okrem najvrchnejsich), v ktorych je clanok zaradeny
    const locationIds = getProp(content, 'location', []).map(
      location => location.id,
    );
    let pills = [];
    pills = [
      ...pills,
      ...locationSmartTags
        .filter(location => locationIds.includes(location.id))
        .map(location => {
          return (
            <Link to={`/lokalita/${location.id}`} key={location.id}>
              <Pill content={location.title} />
            </Link>
          );
        }),
    ];

    pills = [
      ...pills,
      ...getProp(article, 'path', [])
        .filter((item, idx) => {
          return idx > 0 || item.uniqid === 'vasimi-ocami';
        })
        .map(item => {
          return (
            <CsmSectionLink key={item._id} section={item}>
              <Pill content={item.name} />
            </CsmSectionLink>
          );
        }),
    ];

    let mainImage = '';
    let widgets = getProp(content, 'widgets', []);
    for (let widget of widgets) {
      if (widget.type === 'photo') {
        mainImage = `${imageResizeBaseUrl(1000)}/${widget.uri}`;
        break;
      }
    }


    const canonicalUrl = `${process.env.REACT_APP_BASE_URL}${generateArticleUrl(
      article.content,
    )}`;
    const contentHeight =
      this.state.overflow === 'hidden' ? this.state.maxHeight : 'initial';
    return (
      <div>
        <Helmet>
          <title>{content.name}</title>
          {!preview && <meta property="og:title" content={content.name} />}
          {!preview && <meta property="og:type" content="article" />}
          {!preview && <meta property="og:url" content={canonicalUrl} />}
          {!preview &&
            mainImage && <meta property="og:image" content={mainImage} />}
          {!preview && (
            <meta property="og:description" content={content.perex} />
          )}
        </Helmet>
        <a name="article-content">{null}</a>
        <CsmArticlePanorama article={content} pills={[pills]} />
        <div className="container">
          <div className="row">
            <div className="col-sm-12 col-md-9">
              <CsmArticle
                isLoaded={this.setMaxHeight}
                measurable
                allowComments={!preview}
                canonicalUrl={canonicalUrl}
                content={content}
                preview={preview}
              />
            </div>
            {relatedArticles.length > 0 && (
              <div className="col-sm-12 col-md-3">
                <RelatedArticlesBanner />
                <h3 className="relatedArticlesHeader">
                  {this.props.relatedTitle || 'Podobné články'}
                </h3>
                <div
                  className="row article-content-ke"
                  style={{
                    overflow: this.state.overflow,
                    maxHeight: contentHeight,
                  }}
                >
                  {relatedArticles.map(item => {
                    return (
                      <div
                        key={item._id}
                        className="col-xs-12 col-sm-6 col-md-12 relatedArticleItem podobne-clanky"
                        style={{ height: this.state.itemHeight }}
                      >
                        <StandardArticle article={item} />
                      </div>
                    );
                  })}
                </div>
                {this.state.overflow === 'hidden' && (
                  <div
                    onClick={() => {
                      this.setState({
                        overflow: 'auto',
                      });
                    }}
                    style={{
                      fontSize: '18px',
                      textAlign: 'center',
                      padding: '20px 0',
                      fontWeight: 'bold',
                      cursor: 'pointer',
                    }}
                  >
                    <Icon
                      name="chevron-circle-right"
                      styles={{
                        transform: 'rotate(90deg)',
                        width: '26px',
                        height: '26px',
                      }}
                    />
                    <span style={{ paddingLeft: '10px' }}>Ďalšie články</span>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

ArticleDetail.propTypes = {
  dispatch: PropTypes.func.isRequired,
  articles: PropTypes.object.isRequired,
  detail: PropTypes.object.isRequired,
  id: PropTypes.number,
  locationSmartTags: PropTypes.array.isRequired,
  article: PropTypes.object,
  relatedArticles: PropTypes.array,
  relatedTitle: PropTypes.string,
  preview: PropTypes.bool,
};

ArticleDetail.defaultProps = {
  preview: false,
};

export default connect((state, props) => {
  const detailDomain = state.articleDetail.byArticleId;
  const detail = detailDomain[props.id];
  return {
    articles: state.articles,
    detail: detail || {},
    locationSmartTags: state.locationSmartTags.data.values,
  };
})(ArticleDetail);



// WEBPACK FOOTER //
// ./src/app/container/articleDetail.js